import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
export const initGA = () => {
  // Check if we're in production environment to avoid tracking in development
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('G-7GPMQL1V4Z');
    console.log('GA initialized in production mode');
  } else {
    console.log('GA not initialized in development mode');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: 'pageview', page: path });
    console.log(`Page view tracked: ${path}`);
  }
};

// Track events
export const trackEvent = (category, action, label = null, value = null) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
    console.log(`Event tracked: ${category} - ${action} - ${label}`);
  }
};
